import React from 'react';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import RenderTextFieldReduxEmail from '../Complements/RenderTextFieldReduxEmail';
import { Field, reduxForm } from 'redux-form';
import { Grid, Card, CardContent, Icon, Fab } from '@material-ui/core';
import StandardDialog from './StandardDialog';
import RenderSelectFieldRedux from './RenderSelectFieldRedux';
import RenderRadioGroup from './RenderRadioGroup';
//import renderSelectField from './renderSelectField';


const validate = values => {
    const error = {}
    const pattern = new RegExp('^[A-Za-z ]+$', 'i');
    const patternOnlyNumbers = new RegExp('^[0-9]+$', 'i');
    if (!values.name) {
        error.name = "El nombre es un campo obligatorio"
    }
    if (values.name) {
        if (values.name.toString().length > 30) {
            error.name = "El nombre solo permite hasta 30 carácteres."
        }
    }
    if (!pattern.test(values.name)) {
        error.name = "El nombre solo permite letras y espacios"
    }
    if (!values.email) {
        error.email = "El email es un campo obligatorio"
    }
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        error.email = 'Correo electrónico no válido'
    }
    if (!values.number) {
        error.number = "La número de cuenta es un campo obligatorio"
    }
    if (!patternOnlyNumbers.test(values.number)) {
        error.number = "El número de cuenta solo acepta números"
    }
    if (!values.document) {
        error.document = "El tipo de identificación es obligatorio"
    }
    if (!values.cedule) {
        error.cedule = "El campo número de identificación es obligatorio"
    }
    if (!patternOnlyNumbers.test(values.cedule)) {
        error.cedule = "La identificación solo acepta números"
    }

    return error
}

const ExternalForm = props => {
    const { handleSubmit, onCancelAction, entities, submitting, pristine, setDocument, document } = props
    //const [ document, setDocument] = useState('Cédula')
    //console.log('props external', props)
    //console.log(entities.informacionInstituciones)
    //console.log(entities.tiposCuenta)

    return <Card variant="outlined">
        <CardContent>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    {/* <Grid item xs={12} sm = {6} md={6} lg={6}>
                                <Field
                                    data = {entities.informacionInstituciones}
                                    labelId="demo-simple-select-filled-label"
                                    id="entity"
                                    name="entity"
                                    label= { "Entidad" }
                                    onChange ={ e => { changeEntity(e.target.value) } }
                                    component={ RenderSelectFieldRedux } />

                            </Grid> */}

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            data={entities.institucionTransferencias}
                            labelId="demo-simple-select-filled-label"
                            id="institution"
                            name="institution"
                            label={"Seleccione la institución"}
                            component={RenderSelectFieldRedux} />
                        {/* <Field
                                    name="institution"
                                    id= "institution"
                                    component = { renderSelectField }
                                    // onChange ={ e => { changeEntity(e.target.value) } }
                                    value={initialValues.institution}
                                    label="Seleccione la institucion">
                                        {
                                            institutions.map((v, k) => {
                                                return <option key = {v.Secuencial} value={v.Secuencial}>{v.Nombre}</option>
                                            } )
                                        }
                                </Field> */}
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            data={entities.tipoCuentaTransferencias}
                            labelId="demo-simple-select-filled-label"
                            id="type"
                            name="type"
                            label={"Tipo de cuenta"}
                            component={RenderSelectFieldRedux} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            name="document"
                            id="document"
                            required
                            row
                            data={
                                [
                                    { label: 'Cédula', value: '3' },
                                    { label: 'RUC', value: '1' },
                                    { label: 'PASAPORTE', value: '10' },
                                ]
                            }
                            document={document}
                            component={RenderRadioGroup}
                            label="Tipo de identificación"
                            setVal={setDocument}
                            valor={document}
                        //values={document}
                        >
                        </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            withFocus
                            name="cedule"
                            id="cedule"
                            required
                            // valueData = { cedule }
                            component={RenderTextFieldRedux}
                            label={'Número de identificación'}
                            type={"text"}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            withFocus
                            name="number"
                            id="number"
                            required
                            component={RenderTextFieldRedux}
                            label="Número de cuenta"
                            type="text"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>

                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            name="name"
                            id="name"
                            required
                            component={RenderTextFieldRedux}
                            label="Nombre"
                            type="text"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>

                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            withFocus
                            name="email"
                            id="email"
                            required
                            // valueData = {email}
                            component={RenderTextFieldReduxEmail}
                            label="Correo Electrónico"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Field
                            withFocus
                            name="cellphone"
                            id="cellphone"
                            required
                            // valueData = {email}
                            component={RenderTextFieldRedux}
                            label="Teléfono"
                            fullWidth
                        />
                    </Grid>
                    <br></br>
                    <Grid item xs={4} md={4}>
                        <Fab color="primary" aria-label="add" type="submit" disabled={pristine || submitting}  >
                            <Icon>done</Icon>
                        </Fab>
                    </Grid>
                    <Grid item xs={4} md={4}>
                        <Fab style={{ backgroundColor: '#E35959' }} aria-label="add" onClick={() => onCancelAction()}>
                            <Icon>clear</Icon>
                        </Fab>
                    </Grid>
                </Grid>
            </form>
        </CardContent>
    </Card>
}

const ExternalReduxForm = reduxForm(
    {
        form: 'ExternalForm',
        validate,
    }
)(ExternalForm)


const BeneficiaryExternalForm = props => {
    const { onCloseBeneficiaryForm, externalBeneficiary, entities, institutions, changeEntity, onAcceptClick, onDeleteClick, setDocument, document, beneficiaries, handleOpenSnack } = props
    const { open, data } = externalBeneficiary
    //console.log(externalBeneficiary)

    const handleSubmit = (values) => {
        values.document = document;
        //console.log("Data entrada: ", data)
        //console.log("Data saliente: ", values)

        if (data.number !== values.number) {

            const dataResult = beneficiaries.filter((beneficiary) => {

                if ((beneficiary.number === values.number) && (beneficiary.beneficiary === "EXTERNO")) {
                    return true
                } else {
                    return false
                }
            })

            if (dataResult.length === 0) {
                onAcceptClick(values)
            } else {
                handleOpenSnack('El beneficiario ya existe. Por favor verifique los datos.', 'info');
            }
        } else {
            onAcceptClick(values)
        }
    }

    const onDelete = (values) => {
        onDeleteClick(values)
    }



    return (
        <StandardDialog
            title={'Editar beneficiario'}
            open={open}
            handleClose={onCloseBeneficiaryForm}
        >
            <ExternalReduxForm
                onSubmit={handleSubmit}
                onCancelAction={onCloseBeneficiaryForm}
                onDeleteAction={onDelete}
                entities={entities}
                institutions={institutions}
                changeEntity={changeEntity}
                initialValues={data}
                setDocument={setDocument}
                document={data.document}
            />
        </StandardDialog>
    );
};

BeneficiaryExternalForm.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default BeneficiaryExternalForm;
